import axios from '@/utils/api'
import modulo from '@/utils/modulo'

const URL_PROCESSO_FISICO = '/processoFisico'

const actions = {
  async save ({ commit }, processoFisico) {
    const data = await axios({
      method: 'post',
      data: processoFisico,
      url: `${modulo.FINANCEIRO}${URL_PROCESSO_FISICO}/`,
      error: true
    })

    return data
  },

  async findProcessoByNumeroProcesso ({ commit }, numeroProcesso) {
    const data = await axios({
      method: 'get',
      url: `${modulo.FINANCEIRO}${URL_PROCESSO_FISICO}/findByNumero`,
      params: {
        numero: numeroProcesso
      },
      error: true
    })

    return data
  },

  async findDaesByNumeroProcesso ({ commit }, numeroProcesso) {
    const data = await axios({
      method: 'post',
      url: `${modulo.FINANCEIRO}/lista`,
      data: {
        origemDocumento: numeroProcesso
      }
    })

    return data
  },

  async findProcessosByFilter ({commit}, filtroSearch) {
    const data = await axios({
      method: 'post',
      url: `${modulo.FINANCEIRO}${URL_PROCESSO_FISICO}/findByFilter`,
      data: filtroSearch,
      error: true
    })
    return data
  },

  async getCustas ({ commit }) {
    const tiposCustas = await axios({
      method: 'get',
      url: 'financeiro/vtn/tiposCustas'
    })

    return tiposCustas
  }
}

export default {
  namespaced: true,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/financeiro/cadastroProcessoFisico.js